import { render, staticRenderFns } from "./GExamCreateFormFormat.vue?vue&type=template&id=42e3cb24&scoped=true&"
import script from "./GExamCreateFormFormat.vue?vue&type=script&lang=ts&"
export * from "./GExamCreateFormFormat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e3cb24",
  null
  
)

export default component.exports